import { CSSProperties, ReactNode } from "react";

import { Card } from "@/components/Shared/Card";

interface StyledCardProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

const defaultStyles: CSSProperties = {
  width: 350,
  minHeight: 350,
  padding: "20px 10px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  margin: 20,
  boxShadow: "0 6.4px 14.4px #0002, 0 1.2px 3.6px #0000001c",
  borderRadius: 10
};

export function StyledCard({
  children,
  className = "ms-sm6 ms-md4 ms-lg3 ms-xl2",
  style
}: StyledCardProps) {
  return (
    <Card className={className} style={{ ...defaultStyles, ...style }}>
      {children}
    </Card>
  );
}
